// extracted by mini-css-extract-plugin
export default {"wrapper":"UserActivityPage_wrapper__Gik97"};